module.exports={
	"Form": "BidItemCreateManifest",
	"Scope": "BidItem-Create",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-Create-Identity",
				"Group": "BidItem-Create-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-Create-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-Create-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-Create-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-Create-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-Create-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-Create-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-Create-Details",
				"Group": "BidItem-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
